// extracted by mini-css-extract-plugin
module.exports = {"user-acknowledege-container":"UserAcknowledgement_user-acknowledege-container__DZNVq","user-acknowledege-checkbox":"UserAcknowledgement_user-acknowledege-checkbox__PQcfC"};